export default "__VITE_ASSET__9963b203__"